module.exports = __webpack_public_path__ + "img/label-10A4.e3660969.jpeg";